import _ from "lodash";
import store from "@/store";
import moment from "moment-timezone";

const extractValueFromProfile = (
  profile,
  dimensionGroup,
  surveyType,
  valueType,
  interactions,
  dimension,
  surveyEntityId = null,
  closed = false,
  asObject = false
) => {
  var getConstant = store.getters["Constants/getConstant"];
  if (profile && profile[getConstant(dimensionGroup)]) {
    var data = profile[getConstant(dimensionGroup)]
      ? profile[getConstant(dimensionGroup)]
      : false;
    var interactionBySurveyType = {};
    if (surveyEntityId === null) {
      interactionBySurveyType = _.findLast(interactions, interaction => {
        return isNaN(surveyType)
          ? parseInt(interaction.surveyTypeId) ===
              parseInt(getConstant(surveyType)) &&
              (interaction.userEndDate === null || closed)
          : parseInt(interaction.surveyTypeId) === parseInt(surveyType) &&
              interaction.userEndDate === null;
      });
    } else {
      interactionBySurveyType = { surveyEntityId: parseInt(surveyEntityId) };
    }

    if (dimension && data && interactionBySurveyType) {
      if (
        data[getConstant(dimension)] &&
        data[getConstant(dimension)][interactionBySurveyType.surveyEntityId] &&
        !_.isEmpty(
          data[getConstant(dimension)][interactionBySurveyType.surveyEntityId]
        )
      ) {
        var lastValue = _.last(
          _.orderBy(
            data[getConstant(dimension)][
              interactionBySurveyType.surveyEntityId
            ],
            "vigence",
            "ASC"
          )
        );
        return lastValue !== null
          ? asObject
            ? lastValue
            : lastValue[valueType]
          : false;
      } else {
        return false;
      }
    } else {
      return false; // default value
    }
  } else {
    return false;
  }
};
const getClassByValueAndBase = (value, base, color, backgroundColor) => {
  var calcValue = value;
  var calcBase = base;
  if (base === 100) {
    calcValue = value / 10;
    calcBase = 10;
  }
  if (backgroundColor && color) {
    return (
      "base" +
      calcBase +
      "-full" +
      (value !== false ? "-" + parseInt(Math.round(calcValue)) : "")
    );
  } else if (backgroundColor) {
    return (
      "base" +
      calcBase +
      "-bg" +
      (value !== false ? "-" + parseInt(Math.round(calcValue)) : "")
    );
  } else if (color) {
    return (
      "base" +
      calcBase +
      "-color" +
      (value !== false ? "-" + parseInt(Math.round(calcValue)) : "")
    );
  }
};

const getColorByValueAndBase = (value, base, hex = true) => {
  var calcBase = false;
  var calcValue = false;
  if (base === 100) {
    calcBase = 10;
    calcValue = Math.round(parseInt(value) / 10);
  } else if (base === 3) {
    calcBase = 6;
    calcValue = Math.round(parseInt(value)) * 2;
  } else {
    calcBase = parseInt(base);
    calcValue = parseInt(value);
  }

  if (calcBase === 10) {
    if (calcValue === 0) {
      return hex ? "#ea3323" : hexToRgb("#ea3323");
    } else if (calcValue === 1) {
      return hex ? "#ea4025" : hexToRgb("#ea4025");
    } else if (calcValue === 2) {
      return hex ? "#ec5a29" : hexToRgb("#ec5a29");
    } else if (calcValue === 3) {
      return hex ? "#ee7c30" : hexToRgb("#ee7c30");
    } else if (calcValue === 4) {
      return hex ? "#f19d36" : hexToRgb("#f19d36");
    } else if (calcValue === 5) {
      return hex ? "#f5c243" : hexToRgb("#f5c243");
    } else if (calcValue === 6) {
      return hex ? "#cabd40" : hexToRgb("#cabd40");
    } else if (calcValue === 7) {
      return hex ? "#a0b841" : hexToRgb("#a0b841");
    } else if (calcValue === 8) {
      return hex ? "#7ab447" : hexToRgb("#7ab447");
    } else if (calcValue === 9) {
      return hex ? "#5db150" : hexToRgb("#5db150");
    } else if (calcValue === 10) {
      return hex ? "#4ead5b" : hexToRgb("#4ead5b");
    } else if (calcValue >= 11) {
      return hex ? "#3acc4e" : hexToRgb("#3acc4e");
    } else {
      return hex ? "#ababab" : hexToRgb("#ababab");
    }
  } else {
    if (calcValue === 0) {
      return hex ? "#3d9b04" : hexToRgb("#3d9b04");
    } else if (calcValue === 1) {
      return hex ? "#3d9b04" : hexToRgb("#3d9b04");
    } else if (calcValue === 2) {
      return hex ? "#83b301" : hexToRgb("#83b301");
    } else if (calcValue === 3) {
      return hex ? "#11a781" : hexToRgb("#11a781");
    } else if (calcValue === 4) {
      return hex ? "#ebc802" : hexToRgb("#ebc802");
    } else if (calcValue === 5) {
      return hex ? "#f39600" : hexToRgb("#f39600");
    } else if (calcValue === 6) {
      return hex ? "#f91b1b" : hexToRgb("#f91b1b");
    } else {
      return hex ? "#ababab" : hexToRgb("#ababab");
    }
  }
};

const formatNumber = (number, precission) => {
  var multiplier = Math.pow(10, precission);
  return Math.round(number * multiplier) / multiplier;
};

const hexToRgb = hex =>
  hex
    .replace(
      /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
      (m, r, g, b) => "#" + r + r + g + g + b + b
    )
    .substring(1)
    .match(/.{2}/g)
    .map(x => parseInt(x, 16));

const calcEvolution = (
  dimensionGroup,
  dimension,
  surveyType,
  interactions,
  data,
  divider = 1
) => {
  var getConstant = store.getters["Constants/getConstant"];
  var result = {
    series: [],
    discrete: []
  };
  var filteredInteractions = _.filter(
    interactions,
    int => parseInt(int.surveyTypeId) === parseInt(getConstant(surveyType))
  );

  var mergedDimensions = [];
  _.each(filteredInteractions, interaction => {
    if (
      data[getConstant(dimensionGroup)] &&
      data[getConstant(dimensionGroup)] &&
      data[getConstant(dimensionGroup)][getConstant(dimension)] &&
      data[getConstant(dimensionGroup)][getConstant(dimension)][
        interaction.surveyEntityId
      ]
    )
      mergedDimensions = _.concat(
        mergedDimensions,
        data[getConstant(dimensionGroup)][getConstant(dimension)][
          interaction.surveyEntityId
        ]
      );
  });

  if (!_.isEmpty(mergedDimensions)) {
    _.each(mergedDimensions, dimen => {
      var endDate = dimen.startDate;
      result.series.push({
        value: dimen.dimensionValue / divider,
        date: moment(endDate).format("YYYY-MM-DD hh:mm:ss")
      });
    });
    result.series = _.orderBy(result.series, "date");
  }

  if (result.series.length === 1) {
    result.series.push({
      date:
        moment(_.last(result.series).date).format("YYYY-MM-DD") ===
        moment().format("YYYY-MM-DD")
          ? moment(_.last(result.series).date)
              .subtract(1, "days")
              .format("YYYY-MM-DD hh:mm:ss")
          : moment().format("YYYY-MM-DD hh:mm:ss"),
      value: _.last(result.series).value
    });

    result.series = _.orderBy(result.series, "date", "ASC");
  } else if (
    result.series.length > 0 &&
    moment(_.last(result.series).date).format("YYYY-MM-DD") !==
      moment().format("YYYY-MM-DD")
  ) {
    result.series.push({
      date: moment().format("YYYY-MM-DD hh:mm:ss"),
      value: _.last(result.series).value
    });
  }
  return result;
};

export {
  extractValueFromProfile,
  getClassByValueAndBase,
  formatNumber,
  getColorByValueAndBase,
  calcEvolution
};
